export enum CurrenciesEnum {
  'ILS' = 'ILS',
  'UAH' = 'UAH',
  'EUR' = 'EUR',
  'USD' = 'USD',
  'THB' = 'THB',
}